// 推荐视频

import * as React from 'react'

import NoSSR from 'react-no-ssr'
import ScrollLoader from 'Components/scroll-loader'

import Image from 'Components/image'
import Loading from 'Components/loading'
import ArticleLink from 'Components/links/article-link'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import fetchFeed, { IFeedResult } from 'lib/fetch-feed'

export default function RecommandVideos() {
  const [feed, updateFeed] = React.useState<Required<IFeedResult>>({
    data: [],
    tips: {
      display_info: 'hello',
    },
  })
  const [loading, setLoading] = React.useState(false)
  if (!feed || !feed.data) {
    return null
  }
  /* eslint-disable-next-line */
  const loadMoreHandler = React.useCallback(() => {
    let lastFeedItem: IFeedResult['data'][0] | null = null
    if (feed && feed.data) {
      lastFeedItem = feed.data[feed.data.length - 1]
    }
    setLoading(true)
    fetchFeed({
      tt_from: lastFeedItem ? 'load_more' : 'enter_auto',
      category: 'motor_car_video',
      count: 20,
      max_behot_time: lastFeedItem ? lastFeedItem.info.behot_time : undefined,
    }).then(data => {
      setLoading(false)
      sendTeaCommEvent('loadmore_recommend_video', {
        list_item_num: data.data.length,
      })
      updateFeed(lastFeed => {
        return {
          tips: data.tips,
          data: lastFeed.data.concat(data.data),
        }
      })
    })
  }, [feed.data.length])
  return (
    <section>
      <NoSSR onSSR={<Loading />}>
        <div className="card">
          <h4>推荐视频</h4>
          <ScrollLoader
            end={false}
            loading={loading}
            loadMoreHandler={loadMoreHandler}
          >
            <div className="grid list">
              {feed.data.map((news, index) => {
                return (
                  <ArticleLink
                    isVideo
                    key={news.unique_id_str}
                    gid={news.unique_id_str}
                    className="grid-item"
                    onClick={() => {
                      sendTeaCommEvent('click_recommend_video', {
                        group_id: news.unique_id_str,
                        rank: index,
                      })
                    }}
                  >
                    <Image
                      className="img"
                      src={news.info.image_list[0].url}
                      duration={news.info.video_duration}
                      transition={false}
                    />
                    <p className="line-2">{news.info.title}</p>
                  </ArticleLink>
                )
              })}
            </div>
          </ScrollLoader>
          {loading && <Loading />}
        </div>
        <style jsx>
          {`
            h4 {
              padding: 32px 0 15px;
              line-height: 33px;
              font-size: 24px;
            }
            .list :global(.grid-item) {
              width: 230px;
              padding: 0 0 20px;
              margin-right: 10px;
            }
            .list :global(.grid-item:nth-child(5n)) {
              margin-right: 0;
            }
            .grid :global(.img) {
              display: inline-block;
              width: 100%;
              height: 132px;
              margin-bottom: 12px;
              background-size: cover;
            }
            .img:hover {
              transform: scale(1.1);
              transition: transform 0.3s ease-in-out;
            }
            p {
              height: 40px;
              line-height: 20px;
              font-size: 14px;
              word-break: break-all;
            }
            .line-2:hover {
              color: #406599;
            }
            .line-2:visited {
              color: #999999;
            }
          `}
        </style>
      </NoSSR>
    </section>
  )
}
